import { Injectable } from "@angular/core";
import { ShifCreateModel, ShiftViewModel } from "../system/admin-panel/Shifts/Models/ShiftViewModel";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

declare var moment;

export enum DaysOfWeek {
  'Monday' = 0,
  'Tuesday' = 2,
  'Wednesday' = 4,
  'Thursday' = 8,
  'Friday' = 16,
  'Saturday' = 32,
  'Sunday' = 64
}

@Injectable()
export class ShiftsService {
  constructor(private client: HttpClient, private translate: TranslateService) {

  }


  private calculateWorkingTime(shift: ShiftViewModel) {
    let days = [];
    if ((shift.Mask & DaysOfWeek.Monday) == DaysOfWeek.Monday)
      days.push(this.translate.instant("Mn"));
    if ((shift.Mask & DaysOfWeek.Tuesday) == DaysOfWeek.Tuesday)
      days.push(this.translate.instant("Tu"));
    if ((shift.Mask & DaysOfWeek.Wednesday) == DaysOfWeek.Wednesday)
      days.push(this.translate.instant("Wd"));
    if ((shift.Mask & DaysOfWeek.Thursday) == DaysOfWeek.Thursday)
      days.push(this.translate.instant("Th"));
    if ((shift.Mask & DaysOfWeek.Friday) == DaysOfWeek.Friday)
      days.push(this.translate.instant("Fr"));
    if ((shift.Mask & DaysOfWeek.Saturday) == DaysOfWeek.Saturday)
      days.push(this.translate.instant("St"));
    if ((shift.Mask & DaysOfWeek.Sunday) == DaysOfWeek.Sunday)
      days.push(this.translate.instant("Sn"));

    shift.WorkingTime = days.join() + " " + shift.StartTime + " " + shift.EndTime;
  }

  

  public GetShifts() {
    return this.client.get<any>("/ctrl/DriverShifts").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values) {
          let shift = ShiftViewModel.fromJS(item);
          this.calculateWorkingTime(shift);
          result.push(shift);

        }
      }

      return result;
    }));
  }

  public DeleteShift(id) {
    return this.client.delete("/ctrl/DriverShifts/" + id);
  }

  public CreateShift(model: ShiftViewModel) {
    return this.client.post("/ctrl/DriverShifts", new ShifCreateModel(model));
  }
  public EditShift(model: ShiftViewModel) {
    return this.client.put("/ctrl/DriverShifts", new ShifCreateModel(model));
  }
}
